import { Component } from '@angular/core';
import { IframeModeService } from '../../../core/services/iframe-mode.service';
import { AuthService } from '../../../core/services';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent {
  IframeMode = false;
  isAuthenticated$ = this.authService.isAuthenticated$;

  constructor(
    private IframeModeService: IframeModeService,
    private authService: AuthService,
  ) {
    IframeModeService.iframeMode$.subscribe(IframeMode => this.IframeMode = IframeMode);
  }
}
